module.exports = __webpack_public_path__ + "static/img/default-photo-te.388d911.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rtaLogo/default-photo-te.svg
// module id = esdc
// module chunks = 1